import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import logoPower from '../images/logoPowercard.png'

function Login() {

  const navigate = useNavigate()

  const [message, setmessage] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const frontEndUrl = process.env.REACT_APP_REACT_URL

  const [showPassword, setShowPassword] = useState(false);

  const apiUrl = process.env.REACT_APP_BACKEND_URL
  const apiSanctum = process.env.REACT_APP_BACKEND_URL_SANCTUM



  useEffect(() => {
    navigate('/Login')
    axios.get(`${apiSanctum}/csrf-cookie`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",


      },
      withCredentials: true,
    })
  }, [])

  const LoginUser = (e) => {
    e.preventDefault();

    if (email.length === 0 || password.length === 0) {
      setmessage('Tous les champs doivent être remplis')

    }
    else {

      axios.post(`${apiUrl}/LoginUser`,
        {
          email,
          password
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",


          },
          withCredentials: true,

        })
        .then(result => {
          if (result.data.authenticated) {
            if (result.data.active) {
              console.log(result.data.UserId)
              Cookies.set('userId', result.data.UserId, { expires: 30 });
              Cookies.set('UserSpecialToken', result.data.Token, { expires: 30 });
              Cookies.set('IdEntreprise', result.data.company, { expires: 30 });
Cookies.set('UserStatus', result.data.UserStatus, { expires: 30 });
              setEmail('')
              setPassword('')
              setmessage('')
              window.location.href = `${frontEndUrl}/ProfileEdit`
            }
            else {
              setmessage('you account has been disactivated')
            }


          }

          else {
            setmessage('Email ou le mot de passe est invalide')
          }
        })
    }
  }



  return (
    <div className='app-main'>

      <div className="flex items-center justify-center h-screen w-full forms-info">
        <div className="w-full p-5">
          <div className="flex flex-col items-center -mt-14">
            <img src={logoPower} className=' mb-20' style={{width : '14.4rem'}}/>

          </div>
          <form className="space-y-4">
            <div className='sections p-4 pt-6 pb-8 rounded-lg shadow'>
              <p className="font-bold text-center text-auth mb-3 " style={{fontSize : '33px'}}>Authentification</p>

              {message.length > 0 &&
                <div className='w-full bg-red-500 mb-3 dark:bg-gray-700 p-2    rounded'>
                  <p className="text-center font-semibold text-theme font-small">{message}</p>

                </div>
              }

              <div className='w-full'>
                <div className="mt-6 ">
                  <input onChange={(e) => { setEmail(e.target.value) }} type="email" id="email" name="email" className=" block w-full  placeholder-md bg-gray-700 border border-1 inp  rounded placeholder-gray-111  focus:outline-none active " placeholder="Adresse email" required />
                </div>
              </div>
              <div className="relative">
                <div className="mt-6 flex items-center">
                  <input onChange={(e) => { setPassword(e.target.value) }} type={showPassword ? 'text' : 'password'} id="password" name="password" className="inp block w-full placeholder-md bg-gray-700 border border-1 rounded placeholder-gray-111  focus:outline-none active " placeholder="Mot de passe" required />
                  {
                    showPassword == false &&
                    <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 absolute right-3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>

                  }
                  {
                    showPassword == true &&
                    <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 absolute right-3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>

                  }

                </div>
              </div>
              <div>
                <button onClick={(e) => { LoginUser(e) }} type="submit" className="btnnn   w-full flex justify-center  py-2 px-4  border border-transparent rounded shadow-sm text-sm font-medium text-black bg-gold  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold" style={{ fontWeight: 900, fontSize: '22px' }}>
                  Se connecter
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  )
}

export default Login